export default __webpack_public_path__ + "static/media/img-600x400-5.7b820e0a.jpg";